import React, { Component } from 'react';
import { Row, Col, Card, CardHeader, CardBody, Button } from "shards-react";
import Firebase from 'firebase';
import { Link } from 'react-router-dom';
import { StaticRouter } from 'react-router';
import { set } from 'react-ga';
import { Satellite } from '@material-ui/icons';


class QArchiveScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            products:[],
            categories:[],
            selectedProduct:[],
            isProductSelected:false,
            clientUUID:'-ohlnfwebk',
            city:''
        };
    }

    getProducts(){
    
        let ref = Firebase.database().ref('/clients/');
        ref.on('value' , snapshot => {
            this.setState({products:[]})
           
            snapshot.forEach((childSnap) => {
            let state = childSnap.val();
            console.log("resources:"+state);
             this.setState(prevState => ({
                        products: [...prevState.products, state]
                    })) 


        })
    });
    }



    componentDidMount() {
        console.log(Firebase.auth().currentUser.uid)
        this.setState({
            clientUUID: Firebase.auth().currentUser.uid
        })
     

     
                this.getProducts();
            
      
      

        
    }

    changeActive(product){

        for(let k = 0; k <this.state.products.length; k++){
                this.state.products[k].checked = false;
                this.state.products[k].active = 'not-active';
                
                this.setState({
                    products: this.state.products,
                    selectedProduct: [],
                    isProductSelected:false
                })
               
             
        }

        for(let i = 0; i < this.state.products.length; i++){
            if(this.state.products[i].id === product.id && this.state.products[i].checked === false){
                this.state.products[i].active = 'active';
                this.state.products[i].checked = true;
                this.setState({
                    products: this.state.products,
                    selectedProduct: this.state.products[i],
                    isProductSelected:true
                })
            }else if(this.state.products[i].id === product.id && this.state.products[i].checked === true){
                this.state.products[i].active = 'not-active';
                this.state.products[i].checked = false;
                this.setState({
                    products: this.state.products,
                })
            }
        }


      
     
        
       /* this.setState({
            products:this.state.products.filter(item => item.id !== product.id),
        })

        let newProduct = {id:product.id,name:product.name, status:product.status,stock: product.stock,category:product.category,active:'active'}
        this.setState(prevState =>({
            products: [...prevState.products,newProduct]
        }))*/
    }


    deleteProduct(){
        Firebase.database().ref('/cities/'+this.state.city+'/shops/'+Firebase.auth().currentUser.uid+'/products/'+this.state.selectedProduct.id).remove();
        this.setState({
            products:this.state.products.filter(item => item.id !== this.state.selectedProduct.id),
            selectedProduct:[],
            isProductSelected:false
        });

        
    }

    

    render() {
        return (
            <div>
            <Row className="col-sm-12">
                <Col sm={12} className="products-actions">
                    {this.state.isProductSelected ?
                    <div>
                    <Link to={{pathname: `/archief-q-sort-details`,state: {data: this.state.selectedProduct}}} >Bekijken</Link>
                    </div>:null}
                    {/*<Link className="align-button-right" to={{pathname: `/producten/toevoegen`}} >Product toevoegen</Link>*/}
                </Col>
                <Col sm={12} className="products-table">
                
            <table>
                <tr>
                    <th><input type="checkbox" disabled/></th>
                    <th>Klantnaam</th>
                    <th></th>
                    <th></th>
                    <th></th>
                </tr>

                {this.state.products.map((product)=>(
                    <tr className={product.active}>
                    <td><input type="checkbox" checked={product.checked} onClick={()=>this.changeActive(product)}/></td>
                    <td>{product.name}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                ))}
                
            
            </table>
</Col>
   
            </Row>
            </div>



        );
    }
};

export default QArchiveScreen;